/* global $, game */

$.ready(function() {
	var pays = game.pays = $.div('pays').appendTo(game.container);

	pays.canvas = $.element('canvas').appendTo(pays).el.getContext('2d');

	pays.list = [];

	game.on('scale', function() {
		pays.canvas.canvas.width = pays.canvas.canvas.clientWidth;
		pays.canvas.canvas.height = pays.canvas.canvas.clientHeight;
		pays.canvas.lineWidth = Math.max(Math.floor(pays.canvas.canvas.height / 100), 1);
		pays.canvas.lineJoin = 'round';
		pays.canvas.lineCap = 'round';
	});

	pays.init = function(type) {
		this.type = type;
		this.clear();
	};

	pays.add = function(type, pay) {
		var item = {
			box: true,
			type: type,
		};

		if (item.type === 'line') {
			item.color = this.getColor(pay[0], this.lines.length);
			item.win = pay[2];
			item.spots = pay[3];
			item.symbol = pay[4];
			item.line = pay[0];
			item.lineAugment = '';
			item.excludeMult = pay[5] ? 1 : 0;

			if (game.feature.active && game.features.freespin && game.features.freespin.multiplier && !item.excludeMult) {
				if (typeof item.win === 'number') {
					item.win *= game.features.freespin.multiplier;
				}

				else if (item.win.constructor === Array) {
					item.win[0] *= game.features.freespin.multiplier;
					item.win[2] *= game.features.freespin.multiplier;
				}
			}
		}

		else if (item.type === 'way') {
			item.color = this.getColor(pay[0], Object.keys(this.paytable).length + 2);
			item.win = pay[1];
			item.spots = pay[4] || pay[3];
			item.symbol = pay[0];
			if (game.feature.active && game.features.freespin && game.features.freespin.multiplier) {
				if (typeof item.win === 'number') {
					item.win *= game.features.freespin.multiplier;
				}

				else if (item.win.constructor === Array) {
					item.win[0] *= game.features.freespin.multiplier;
					item.win[2] *= game.features.freespin.multiplier;
				}
			}

			var waysCount = [];

			for (var i = 0; i < item.spots.length; i++) {
				var reelPos = item.spots[i][0];

				if (!waysCount[reelPos]) {
					waysCount[reelPos] = 0;
				}

				waysCount[reelPos]++;
			}

			var numWays = 1;

			for (var i = 0; i < waysCount.length; i++) {
				if (waysCount[i] !== undefined) {
					numWays *= waysCount[i];
				}
			}

			item.numWays = numWays;
		}

		else if (item.type === 'scatter') {
			item.color = this.getColor(pay[0], Object.keys(this.paytable).length + 2);
			item.win = pay[2];
			item.spots = pay[3];
			item.symbol = pay[0];
			if (game.feature.active && game.features.freespin && game.features.freespin.multiplier) {
				if (typeof item.win === 'number') {
					item.win *= game.features.freespin.multiplier;
				}

				else if (item.win.constructor === Array) {
					item.win[0] *= game.features.freespin.multiplier;
					item.win[2] *= game.features.freespin.multiplier;
				}
			}
		}

		if (typeof item.win === 'string') {
			item.win = item.win.replace(/_/g, ' ').replace(/\w\S*/g, function(word) {
				return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
			});
		}

		else if (typeof item.win === 'number') {
			item.win = $.plugins.meter.__format(item.win);
		}

		else if (item.win.constructor === Array) {
			item.win = [
				$.plugins.meter.__format(item.win[0]),
				'x',
				$.plugins.meter.__format(item.win[1]),
				'=',
				$.plugins.meter.__format(item.win[2]),
			].join(' ');
		}

		this.trigger('pay', item);

		this.list.push(item);
	};

	pays.show = function(cycles) {
		if (!this.list.length) {
			return;
		}

		if (pays.forceCycles) {
			cycles = 1;
		}

		this.canvas.shadowOffsetX = 0;
		this.canvas.shadowOffsetY = 0;
		this.canvas.shadowBlur = 0;
		this.canvas.shadowColor = 'black';

		timer = setTimeout(function() {
			game.messaging.show('pays');
			pays.next(0, cycles ? cycles : 0);
		}, 500);
	};

	pays.clear = function(hold, hide) {
		if (!hold) {
			pays.list = [];
		}

		if (!hold || hide) {
			game.messaging.hide('pays');
			clearTimeout(timer);
		}

		this.canvas.clearRect(0, 0, this.canvas.canvas.width, this.canvas.canvas.height);

		game.frame.removeClass('win');

		for (var reel in game.frame.reels) {
			for (var row in game.frame.reels[reel].symbols) {
				game.frame.reels[reel].symbols[row].removeClass('win pop');
			}
		}
	};

	var timer = null;

	pays.next = function(index, cycles) {
		if (!this.list.length) {
			return null;
		}

		if (index >= this.list.length) {
			return this.next(0, cycles + 1);
		}

		if (cycles === 0 && this.list.length === 1) {
			return this.next(0, cycles + 1);
		}

		var pay = this.list[index];

		this.clear(true);
		this.canvas.strokeStyle = pay.color;

		if (typeof pay.line !== 'undefined') {
			this.drawLine(pay.line, null, pay);
		}

		for (var spot in pay.spots) {
			spot = pay.spots[spot];
			var pos_override = [];
			pays.trigger('next', { pay: pay, spot: spot, pos_override: pos_override, cycles: cycles });

			var reel = spot[0];
			var row = spot[1];

			if (cycles > 0) {
				game.frame.reels[reel].symbols[row].addClass('win');

				var symbol = game.frame.reels[reel].symbols[row];
				symbol.css('width', symbol.el.offsetWidth);
			}

			else {
				game.frame.reels[reel].symbols[row].addClass('pop');
			}

			// x, y, width, height
			var pos = this.getPosition(reel, row);
			if (pos_override.length === 4) {
				pos = pos_override;
			}

			pos[0] += this.canvas.lineWidth / 2;
			pos[1] += this.canvas.lineWidth / 2;
			pos[2] -= this.canvas.lineWidth;
			pos[3] -= this.canvas.lineWidth;

			if (pay.box) {
				this.canvas.clearRect(pos[0], pos[1], pos[2], pos[3]);
				this.canvas.strokeRect(pos[0], pos[1], pos[2], pos[3]);
			}
		}

		game.frame.addClass('win');

		if (pay.type === 'line') {
			var symbol = '<span class="mini symbol-' + pay.symbol + '" ></span>';
			pays.messaging.html('Symbol ' + symbol + ' wins ' + pay.win + ' on Line ' + (pay.line + 1) + pay.lineAugment);
			pays.trigger('update', { line: pay.line + 1 });
		}

		else if (pay.type === 'way') {
			var symbol = '<span class="mini symbol-' + pay.symbol + '" ></span>';
			pays.messaging.html('Symbol ' + symbol + ' by ' + pay.numWays + ' wins ' + pay.win);
		}

		else if (pay.type === 'scatter') {
			var symbol = '<span class="mini symbol-' + pay.symbol + '" ></span>';
			pays.messaging.html('Scatter symbol ' + symbol + ' wins ' + pay.win);
			pays.trigger('updateScatter', { pay: pay.win });
		}

		var time = 500;
		if (cycles === 0 && game.pays.cycleTime) {
			time = game.pays.cycleTime;
		}
		else if (game.pays.time) {
			time = game.pays.time;
		}
		else if (cycles !== 0) {
			time = 2000;
		}

		timer = setTimeout(pays.next.bind(pays, index + 1, cycles), time);
	};

	game.on('ui', function(config) {
		config = config.detail;

		delete pays.wild;
		delete pays.lines;
		delete pays.cost;
		delete pays.scatters;

		pays.paytable = [];

		if (config.lines) {
			pays.wild = config.lines.wild;
			pays.lines = config.lines.lines;

			for (var key in config.lines.paytable) {
				if (pays.paytable.indexOf(key) === -1) {
					pays.paytable.push(key);
				}
			}

			pays.init('lines');
		}

		if (config.ways) {
			pays.wild = config.ways.wild;
			pays.cost = config.ways.cost;

			for (var key in config.ways.paytable) {
				if (pays.paytable.indexOf(key) === -1) {
					pays.paytable.push(key);
				}
			}

			pays.init('ways');
		}

		if (config.scatters) {
			pays.scatters = {};

			if (config.scatters.constructor === Array) {
				for (var i in config.scatters) {
					if (config.scatters[i].sequential) {
						pays.scatters.sequential = config.scatters[i].sequential;
					}

					if (config.scatters[i].block) {
						pays.scatters[config.scatters[i].block] = 'block';
					}

					for (var key in config.scatters[i].paytable) {
						if (pays.paytable.indexOf(key) === -1) {
							pays.paytable.push(key);
						}
					}
				}
			}

			else {
				if (config.scatters.sequential) {
					pays.scatters.sequential = config.scatters.sequential;
				}

				if (config.scatters.block) {
					pays.scatters[config.scatters.block] = 'block';
				}

				for (var key in config.scatters.paytable) {
					if (pays.paytable.indexOf(key) === -1) {
						pays.paytable.push(key);
					}
				}
			}
		}
	});
});



/** WEBPACK FOOTER **
 ** ./../../public-src/common/js/container-pays.js
 **/